import React, { Component, Fragment } from 'react';
import { shape, number, any, string, oneOfType, func, bool, objectOf } from 'prop-types';
import { get } from "lodash";
import cx from 'classnames';
import AdsPerformanceChart from './AdsPerformanceChart';
import AdsPerformanceSummary from '../../components/PerformanceSummary';
import DateRangeComponent from "../DateRange";
import ModuleExport from '../ModuleExport';
import { calAdperformanceRange, defaultAdperformanceRangeValue } from './util';
import { convertTimezoneDate } from "../../helpers/formatData";
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';
import VeritoneLoading from "../DashboardTab/VeritoneLoading";
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Help from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './styles.scss';
import { AD_PERFORMANCE_CHART_ID } from "../../helpers/constant";
import { getChartDataKey } from '../../helpers/formatData';
import DeleteReportItemButton from '../DeleteReportItem';

const useStyles = {
  container: {},
  arrowDownIcon: {
    color: '#2196f3'
  },
  tooltip: {
    maxWidth: 230
  }
}

const typeOptions = [
  {
    type: 'visit',
    dropdownTitle: 'Total Visits',
    yAxisTitle: 'Total Visits',
    withAdsTitle: 'Daily avg. visits with ads',
    withoutAdsTitle: 'Daily avg. visits without ads',
  },
];

const dateRangeTitle = `Days Before Campaign`;
const dateRangeDescriptions = `Web activity for the days selected are averaged for the 'without ads' value`;
const FILE_NAME = 'web_ads_performance';

class AdsPerformance extends Component {
  static defaultProps = {
    title: "Total Change"
  }
  static propTypes = {
    data: shape({
      dayWithAds: shape({
        visit: oneOfType([number, string]),
        user: oneOfType([number, string])
      }),
      dayWithoutAds: shape({
        visit: oneOfType([number, string]),
        user: oneOfType([number, string])
      }),
    }),
    classes: shape({any}),
    advertiser: shape({any}),
    onCompareDateChange: func,
    changeDateRange: func,
    showToast: func,
    loadAdperformanceChartDataSaga: func,
    campaign: shape({
      campaign_id: number
    }),
    setChartSelector: func,
    title: string,
    areAdSourcesEnabled: bool,
    isCustomReport: bool,
    showDeleteTotalVisitsByAdChart: bool,
    isChartVisibleReport: shape({}),
    currentStep: string,
    itemIndex: number,
    // totalVisitsByAdChartSelector: objectOf(string),
    setReportChartSelector: func,
  }

  state = {}

  onChangeDateRange = (adPerformanceRange) => {
    const { campaign, advertiser, loadAdperformanceChartDataSaga, areAdSourcesEnabled } = this.props;
    const campaignId = campaign.campaign_id;
    const advertiserId = advertiser.advertiser_id;
    
    const startCampaignString = campaign && campaign.start_date;
    const endCampaignString = campaign && campaign.end_date;
    const startCampainDate = startCampaignString || new Date();
    const endCampaignDate = endCampaignString || new Date();
    const timezoneKey = get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const startCampaign = convertTimezoneDate(startCampainDate, timezoneKey, true);
    const endCampaign = convertTimezoneDate(endCampaignDate, timezoneKey, false);
    const startDateAdperformance = convertTimezoneDate(adPerformanceRange && adPerformanceRange.start, timezoneKey, true);
    const endDateAdperformance = convertTimezoneDate(adPerformanceRange && adPerformanceRange.end, timezoneKey, false);
    const { availableAdSources, selectedAdSources } = campaign;

    const availableAdSourcesKey = getChartDataKey({
      range: {
        start: startCampainDate,
        end: endCampaignDate,
        timezone: timezoneKey
      }
    });

    const newAvailableAdSources = areAdSourcesEnabled ? get(availableAdSources, [availableAdSourcesKey], []).sort() : null;
    const chartDataKey = getChartDataKey({
      selectedAdSources: selectedAdSources || newAvailableAdSources,
      range: {
        start: startCampainDate,
        end: endCampaignDate,
        timezone: timezoneKey
      }
    });

    const rangeAdperformance = `${startDateAdperformance} - ${endDateAdperformance}`;
    const rawChartData = get(campaign, ['chartData', chartDataKey], {});
    const isChartExist = get(rawChartData, [ AD_PERFORMANCE_CHART_ID, rangeAdperformance]);

    if (campaignId > 0 && !isChartExist) {
      loadAdperformanceChartDataSaga(campaignId, advertiserId, {
        startCampaign,
        endCampaign,
        startDateAdperformance,
        endDateAdperformance,
        rangeMaster: chartDataKey,
        rangeAdperformance
      });
    }
  }

  // handleSelectionChange = (e) => {
  //   const value = e.target.value;
  //   value && this.setState({
  //     performanceType: value
  //   })
  // }

  // getData() {
  //   const [ typeA, typeB ] = typeOptions;
  //   const { dayWithAds, dayWithoutAds } = this.props.data;
  //   const performanceType = this.state.performanceType || typeA.value;
  //   const objData = {};
  //   const withAds = parseFloat(dayWithAds[performanceType]);
  //   const withoutAds = parseFloat(dayWithoutAds[performanceType]);
  //   let withAdsTitle = typeA.withAdsTitle;
  //   let withoutAdsTitle = typeA.withoutAdsTitle;
  //   objData.yAxisTitle = typeA.yAxisTitle;
    
  //   if ( performanceType !== typeA.value ) {
  //     withAdsTitle = typeB.withAdsTitle;
  //     withoutAdsTitle = typeB.withoutAdsTitle;
  //     objData.yAxisTitle = typeB.yAxisTitle;
  //   }
    

  getData = (primaryTitle, secondaryTitle, parseDataWithAds, parseDataWithoutAds) => {
    return [
      {
        category: primaryTitle,
        y: parseDataWithAds || 0,
        x: 0
      },
      {
        category: secondaryTitle,
        y: parseDataWithoutAds || 0,
        x: 2
      }
    ];
  }
  
  drawDropdown() {
    const typeSelectedDataForChart = this.getTypeSelectForData();
    const { classes } = this.props;
    return(
      <FormControl className={styles.selectForm} data-test="dataTypeSelectBtn">
        <Select
          value={typeSelectedDataForChart}
          onChange={this.handleSelectionChange}
          className={styles.selectItem}
          inputProps={{
            classes: {
              icon: classes.arrowDownIcon,
            }
          }}
          data-test="1232132se"
        >
        {typeOptions.map( typeData => {
          return <MenuItem value={typeData.type} key={typeData.type}>{typeData.dropdownTitle}</MenuItem>
        })}
        </Select>
      </FormControl>
    )
  }

  handleSelectionChange = (e) => {
    const value = e.target.value;
    const { campaign, setChartSelector, setReportChartSelector, itemIndex } = this.props;
    setChartSelector(campaign.campaign_id, AD_PERFORMANCE_CHART_ID, { type: value });
    setReportChartSelector && setReportChartSelector(AD_PERFORMANCE_CHART_ID, itemIndex, { type: value });
  }
 
  getTypeSelectForData = () => {
    const { campaign } = this.props;
    const [ firstOption ] = typeOptions;
    return get(campaign, ["chartSelector", AD_PERFORMANCE_CHART_ID, "type"], firstOption.type);
  }

  prepCsvData(data) {
    return data && data.reduce((accum, currentEntry)=> {
      const { category, y } = currentEntry;
      accum.push([category, y]);
      return accum;
    }, [['Category', 'Total Visits']]);
  }

  exportContainer = React.createRef();
  render() {
    const { 
      campaign,
      advertiser,
      onCompareDateChange,
      classes,
      showToast,
      changeDateRange,
      data,
      title,
      isCustomReport,
      isChartVisibleReport,
      showDeleteTotalVisitsByAdChart,
      currentStep,
      itemIndex,
    } = this.props;
    const [ firstType ] = typeOptions;

    //get value and 2 title for primary and secondary text
    const typeSelectedDataForChart = this.getTypeSelectForData();
    const itemSelectedDataForChart = firstType
    const primaryTitle = get(itemSelectedDataForChart, "withAdsTitle");
    const secondaryTitle = get(itemSelectedDataForChart, "withoutAdsTitle");
    const yAxisTitle = get(itemSelectedDataForChart, 'yAxisTitle');

    //get data and create chart data
    const dataWithAds = get(data, ["dayWithAds" , typeSelectedDataForChart], 0) || 0;
    const parseDataWithAds = !dataWithAds ? 0 : parseFloat(dataWithAds);
    const dataWithoutAds = get(data, ["dayWithoutAds", typeSelectedDataForChart], 0) || 0;
    const parseDataWithoutAds = !dataWithoutAds ? 0 : parseFloat(dataWithoutAds);
    const chartData = this.getData(primaryTitle, secondaryTitle, parseDataWithAds, parseDataWithoutAds);
    const campaignId = campaign && campaign.campaign_id;
    const disabled = !(campaignId > 0);
    const { isTotalVisitsByAdChartVisible } = isChartVisibleReport;
    const titleCalendar = <div className={styles.descriptions}>
                  <div className={styles.title}>{dateRangeTitle}</div>
                    <Tooltip
                      placement="top"
                      title={dateRangeDescriptions}
                      classes={{tooltip: classes.tooltip}}
                      data-test="tooltipAdsPerformance"
                    >
                      <Help className={styles.icon} />
                    </Tooltip>
                  </div>

    const campaignStartDate = campaign && campaign.start_date;
    const dateRangeList = campaignStartDate && calAdperformanceRange(campaignStartDate);
    const isLoading = get(campaign, ['chartLoading', AD_PERFORMANCE_CHART_ID]) === "loading";

    return (
      <Fragment>
        {!isCustomReport || isCustomReport && isTotalVisitsByAdChartVisible ?
          <div className={cx({[styles.adsPerformanceContainerMainView]: !isCustomReport}, styles.adsPerformanceContainer)}>
            <div className={cx({[styles.itemContainer]: showDeleteTotalVisitsByAdChart, [styles.deleteItemContainer]: currentStep === 'customize'})}>
              {showDeleteTotalVisitsByAdChart &&
                <DeleteReportItemButton
                  isDelete={showDeleteTotalVisitsByAdChart}
                  parentId="webAnalytics"
                  componentId="totalVisitsByAdChart"
                  customClassName={styles.deleteButton}
                  itemIndex={itemIndex}
                />
              }
              <ModuleExport
                exportImg={this.exportContainer}
                data={this.prepCsvData(chartData)}
                fileName={FILE_NAME}
              />
              <div data-test="adsPerformanceChart" className={styles.adsPerformanceExportContainer} ref={this.exportContainer}>
                {isLoading &&
                  <div className={styles.loading}>
                    <VeritoneLoading />
                </div>
                }
                <div className={styles.totalChangeTitle }>
                  <div className={styles.title}>{title}</div>
                </div>
                <div className={styles.selectPerformanceType}>
                  {this.drawDropdown()}
                </div>
              <div className={styles.AdsPerformanceContent}>
                  <div className={styles.adsPerformanceChart}>
                    <AdsPerformanceChart
                      data={chartData}
                      yAxisTitle={yAxisTitle}
                    />
                  </div>
                  <div className={styles.adsPerformanceSummary}>
                      <div className={styles.divier} />
                      <AdsPerformanceSummary
                        campaign={campaign}
                        advertiser={advertiser}
                        primaryTitle={primaryTitle}
                        secondaryTitle={secondaryTitle}
                        primaryData={parseDataWithAds}
                        secondaryData={parseDataWithoutAds}
                        onCompareDateChange={onCompareDateChange}
                      />
                      <div className={styles.datePicker}>
                        <DateRangeComponent
                          campaign={campaign}
                          advertiser={advertiser}
                          typePicker={"adPerformanceCalendar"}
                          changeDateRange={changeDateRange}
                          onChange={this.onChangeDateRange}
                          showToast={showToast}
                          customSelect
                          fullWidth={false}
                          isShowDataCollected
                          title={titleCalendar}
                          dateRangeList={dateRangeList}
                          disabled={disabled}
                          defaultValue={defaultAdperformanceRangeValue}
                        />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''
        }
      </Fragment>
    )
  }
}

import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    currentStep: get(state, 'reportBuilder.currentStep'),
  }
}

export default connect(mapStateToProps)(withStyles(useStyles)(AdsPerformance));
